import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=9ca6feb2&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=9ca6feb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca6feb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ca6feb2')) {
      api.createRecord('9ca6feb2', component.options)
    } else {
      api.reload('9ca6feb2', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=9ca6feb2&scoped=true&", function () {
      api.rerender('9ca6feb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Waiting/Modal.vue"
export default component.exports